import React from 'react';

import {StateColors} from './StateBadge'
import MultiButtonSwitch from '../common/editors/MultiButtonSwitch';
import _ from 'lodash';

// Copied from ExposedDataFeedback.state, but it's better to avoid including that class in the admin front-end bundle
const states = {
  NEW: 'new',
  UNCLEAR: 'unclear',
  REJECTED: 'rejected',
  OPEN: 'open',
  WONT_FIX: 'wontfix',
  SOLVED: 'solved',
};

export default function DataFeedbackStateSwitch({ value, onChange, nullable = false }) {
  const options = _.values(states);

  return <MultiButtonSwitch value={value} nullable={nullable} onChange={onChange} options={options} optionColorMap={StateColors}/>
}
